import script from "./ECombobox.vue?vue&type=script&setup=true&lang=js"
export * from "./ECombobox.vue?vue&type=script&setup=true&lang=js"

import "./ECombobox.vue?vue&type=style&index=0&id=3e33ede2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lms-v3-backend/lms-v3-backend/.vapor/build/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e33ede2"]])

export default __exports__